module.exports = __webpack_public_path__ + "images/fc263f21032344a52fa245da287584d0-IMG_0237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_0237.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_0237.jpg
// module chunks = 0